var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('validated-text-field',{attrs:{"value":_setup.amount,"autofocus":"","rules":"required|amount|min_value:0.5","label":_vm.$t('label.price')},on:{"input":_setup.priceChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }